module.exports = __webpack_public_path__ + "1af27b71e5d8c76382a721998087b45d.svg";